<script>
    import client from "../client";
    import { onMount } from "svelte";
    import { convertDateTimeMonthAndDay } from "../utils/dates";
    import SvelteTable from "svelte-table";
    import ClockAnimation from "../components/images/ClockAnimation.svelte";
    import page, { redirect } from "page";
    export let params;

    let alert_message;
    let athlete = "";
    let loading = true;
    let results = [];

    onMount(async () => {
        try {
          if (params.id && params.name && params.surname) {
            let racesT = await client.service('results').find({
              query: {
                  option : "athleteRaces",
                  athleteId : params.id,
              }
            });
            for (let index = 0; index < racesT.length; index++) {
              const race = racesT[index];
              if (race) {
                if (race.firstname == params.name && race.surname == params.surname) {
                  results.push(race);
                }
              }
            }
            athlete = params.name + ' ' + params.surname;
            loading = false;
          }
        } catch(err) {
            console.error(err);
            alert_message = "Error Retrieving Athlete's Races";
            loading = false;
        }
    });

    const columns = [
      {
        key: "start",
        title: "Date",
        value: v => v.start,
        sortable: false,
        headerClass: "text-center",
      },
      {
        key: "ename",
        title: "Event",
        value: v => v.ename,
        sortable: false,
        headerClass: "text-left",
      },
      {
        key: "race_number",
        title: "Race Number",
        value: v => v.race_number,
        sortable: false,
        headerClass: "text-center",
      },
      {
        key: "duration",
        title: "Duration",
        value: v => v.duration,
        sortable: false,
        headerClass: "text-center",
      },
      {
        key: "position",
        title: "Position",
        value: "",
        sortable: false,
        headerClass: "text-left",
      },
      {
        key: "gender",
        title: "Gender",
        value: "",
        sortable: false,
      },
      {
        key: "catergory",
        title: "Category",
        value: "",
        sortable: false,
      },
      {
        key: "eid",
        title: "Race",
        value: "",
        sortable: false,
      },
    ];
</script>

<div class="card" style="margin-top:10px;">
    <div class="card-content">
      <p class="title">
        {athlete}
      </p>
      <p class="subtitle">
        List of all races for athlete.
      </p>
      
        {#if alert_message}
        <div class="notification is-light is-danger">{@html alert_message}</div>
        {/if}

        {#if loading}
          <div style="width:200px;margin-left:auto;margin-right:auto;">
          <ClockAnimation />
          </div>
        {:else}
        {#if results.length > 0}
          <div class="table-container">
          <SvelteTable 
            columns={columns} 
            rows={results} 
            classNameTable={['table is-hoverable is-fullwidth']} 
          >
            <tr slot="row" let:row let:n>
              <td>{convertDateTimeMonthAndDay(row.start, 2)}</td>
              <td>{row.ename}</td>
              <td>{row.race_number}</td>
              <td>{row.duration}</td>
              <td><span class="tag is-link is-small has-text-weight-bold">{row.position}</span> {row.aname}</td>
              <td><span class="tag is-link is-small has-text-weight-bold">{row.position_gender}</span> {row.gender}</td>
              <td><span class="tag is-link is-small has-text-weight-bold">{row.position_category}</span> {row.category}</td>
              <td>
                <button class="button is-small is-primary" on:click={() => page.redirect("/"+row.eid+"/"+row.aid)}>
                  <span class="icon is-small">
                    <i class="fa fa-link"></i>
                  </span>
                </button>
              </td>
            </tr>
          </SvelteTable>
          </div>
        {/if}
        {#if results.length == 0 && athlete}
        <div class="notification is-light is-warning">No Races for Selected Athlete.</div>
        {/if}
      {/if}
      
    </div>
  </div>